import { Fragment, useState, useRef, useEffect } from "react";
import {
  Autocomplete,
  Switch,
  Grid2 as Grid,
  FormControlLabel,
  TextField,
  IconButton,
  CircularProgress,
} from "@mui/material";
import BTDialogBox from "../../../components/BTDialgBox";
import BTInput from "../../../components/BTInput";
import BTButton from "../../../components/BTButton";
import BTDivider from "../../../components/BTDivider";
import BTTypography from "../../../components/BTTypography";
import { isEqual } from "lodash";
import secureLocalStorage from "react-secure-storage";
import authService from "../../../services/auth-service";
import { useNotification } from "../../../context";
import { Notifications, Cancel } from "@mui/icons-material";
import { useDispatch } from "react-redux";
import { get, insert, update, remove } from "../../../store/labSlice";
const Addparty = ({ open, setOpen }) => {
  const dispatch = useDispatch();
  const { addNotification } = useNotification();
  const { value, actionType } = open;
  const { u_id, admin_u_id, u_type } = secureLocalStorage.getItem("userdata");
  const initialCompanyState = {
    p_org_name: null,
    p_org_address_line1: null,
    p_org_address_line2: null,
    p_org_mo_no_1: null,
    p_org_mo_no_2: null,
    p_org_email: null,
    p_org_gst: null,
  };
  const initialState = {
    p_name: null,
    p_address: null,
    p_mo_no: null,
    p_email_1: null,
    p_email_2: null,
    p_contact_person_1: null,
    p_contact_person_2: null,
    p_contact_person_1_mo_no: null,
    p_contact_person_2_mo_no: null,
    p_org_name: null,
    p_org_address_line1: null,
    p_org_address_line2: null,
    p_org_mo_no_1: null,
    p_org_mo_no_2: null,
    p_org_email: null,
    p_org_gst: null,
    p_org_pincode: null,
    p_allias: [],
    p_ref_name: null,
    p_ref_mo_no: null,
    label: null,
    p_code: null,
    p_prefix_code: null,
    p_description: null,
    admin_u_id: u_type === 1 ? u_id : admin_u_id,
    p_created_by: u_id,
    p_updated_by: u_id,
  };
  const [formData, setFormData] = useState(
    actionType === 1 ? initialState : value
  );
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const scrollRef = useRef(null);
  const validateForm = (data) => {
    const {
      p_name,
      p_address,
      p_mo_no,
      p_email_1,
      p_email_2,
      p_contact_person_1_mo_no,
      p_contact_person_2_mo_no,
      p_org_name,
      p_org_address_line1,
      p_org_address_line2,
      p_org_mo_no_1,
      p_org_mo_no_2,
      p_org_email,
      p_org_gst,
      label,
      p_code,
      p_prefix_code,
      p_ref_mo_no,
      p_ref_name,
      p_allias,
    } = data;

    const errors = {};
    const addError = (field, message) =>
      (errors[field] = message || `${field.replace(/_/g, " ")} is required`);

    // Required Field Validations
    const requiredFields = {
      p_name: "Party name",
      p_address: "Party address",
      p_mo_no: "Party mobile number",
      p_email_1: "Party email 1",
      p_org_name: "Organization name",
      p_org_gst: "GST number",
      p_code: "Party code",
    };

    Object.entries(requiredFields).forEach(([field, label]) => {
      if (!data[field]?.trim()) addError(field, `${label} is required`);
    });

    // Mobile Number Validations
    const validateMobile = (number, field) => {
      const mobileRegex = /^[0-9]{10}$/;
      if (number && !mobileRegex.test(number)) {
        addError(field, "Please enter a valid 10-digit mobile number");
      }
    };
    validateMobile(p_contact_person_1_mo_no, "p_contact_person_1_mo_no");
    validateMobile(p_contact_person_2_mo_no, "p_contact_person_2_mo_no");
    validateMobile(p_mo_no, "p_mo_no");
    validateMobile(p_org_mo_no_1, "p_org_mo_no_1");
    validateMobile(p_org_mo_no_2, "p_org_mo_no_2");
    validateMobile(p_ref_mo_no, "p_ref_mo_no");
    // Email Validations
    const validateEmail = (email, field) => {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (email && !emailRegex.test(email)) {
        addError(field, "Please enter a valid email address");
      }
    };
    validateEmail(p_email_1, "p_email_1");
    validateEmail(p_email_2, "p_email_2");
    validateEmail(p_org_email, "p_org_email");
    p_allias.forEach((company, index) => {
      const companyRequiredFields = {
        p_org_name: "Organization name",
        p_org_gst: "GST number",
      };

      Object.entries(companyRequiredFields).forEach(([field, label]) => {
        if (!company[field]?.trim()) {
          addError(`companies[${index}].${field}`, `${label} is required`);
        }
      });
    });

    return Object.keys(errors).length > 0 ? errors : {};
  };
  const handleClose = () => {
    setOpen(false);
    setFormData(initialState);
  };

  const submitParty = async (e) => {
    e.preventDefault();
    const newErrors = validateForm(formData);
    setErrors(newErrors);
    if (Object.keys(newErrors).length === 0) {
      if (actionType === 2 && isEqual(formData, value)) {
        return addNotification({
          icon: <Notifications color="white" />,
          title: "Error!",
          message: "No changes to save",
          color: "error",
        });
      } else {
        try {
          setLoading(true);
          const isNewparty = !formData?.p_id;
          const response = isNewparty
            ? await authService.insert_party({ attributes: formData })
            : await authService.update_party({ attributes: formData });
          if (response?.status === 1) {
            isNewparty
              ? dispatch(
                  insert({
                    name: "parties",
                    data: response?.data,
                    fetch: true,
                  })
                )
              : dispatch(
                  update({
                    name: "parties",
                    key: "p_id",
                    data: response?.data,
                    fetch: true,
                  })
                );
            addNotification({
              icon: <Notifications color="white" />,
              title: "Success!",
              message: response?.message,
              color: "success",
            });
            handleClose();
          }
        } catch (error) {
          addNotification({
            icon: <Notifications color="white" />,
            title: "Error!",
            message: "Somthing Went Wrong!",
            color: "error",
          });
        } finally {
          setLoading(false);
        }
      }
    }
  };

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    if (
      name === "p_mo_no" ||
      name === "p_ref_mo_no" ||
      name === "p_contact_person_1_mo_no" ||
      name === "p_contact_person_2_mo_no"
    ) {
      if (value === "" || /^[0-9]+$/.test(value)) {
        const fieldValue = type === "checkbox" ? checked : value;
        setFormData((prev) => ({
          ...prev,
          [name]: fieldValue,
        }));
        const newErrors = validateForm({ ...formData, [name]: fieldValue });
        if (Object.keys(newErrors).length === 0) {
          setErrors((prevErrors) => {
            const { [name]: removedError, ...rest } = prevErrors;
            return rest;
          });
        } else {
          setErrors((prevErrors) => ({
            ...prevErrors,
            [name]: newErrors[name] || null,
          }));
        }
      }
    } else {
      const fieldValue = type === "checkbox" ? checked : value;
      setFormData((prev) => ({
        ...prev,
        [name]: fieldValue,
      }));
      const newErrors = validateForm({ ...formData, [name]: fieldValue });
      if (Object.keys(newErrors).length === 0) {
        setErrors((prevErrors) => {
          const { [name]: removedError, ...rest } = prevErrors;
          return rest;
        });
      } else {
        setErrors((prevErrors) => ({
          ...prevErrors,
          [name]: newErrors[name] || null,
        }));
      }
    }
  };

  const handleAutocompleteChange = (name, value) => {
    let fieldValue = value?.value || "";
    setFormData((prev) => ({
      ...prev,
      [name]: fieldValue,
    }));
    const newErrors = validateForm({ ...formData, [name]: fieldValue });
    if (Object.keys(newErrors).length === 0) {
      setErrors((prevErrors) => {
        const { [name]: removedError, ...rest } = prevErrors;
        return rest;
      });
    } else {
      setErrors((prevErrors) => ({
        ...prevErrors,
        [name]: newErrors[name] || null,
      }));
    }
  };

  const handleSwitchChange = (name) => (e) => {
    setFormData((prev) => ({
      ...prev,
      [name]: e.target.checked ? 1 : 0,
    }));
  };
  const handleCompanyChange = (index, e) => {
    const { name, value, type, checked } = e.target;
    const fieldValue = type === "checkbox" ? checked : value;
    setFormData((prev) => {
      const updatedCompanies = [...prev.p_allias];
      updatedCompanies[index] = {
        ...updatedCompanies[index],
        [name]: fieldValue,
      };
      return {
        ...prev,
        p_allias: updatedCompanies,
      };
    });
  };
  const renderField = (field) => {
    const error = errors[field?.name];
    switch (field.type) {
      case "select":
        return (
          <Autocomplete
            options={field?.options}
            value={
              field?.options.find(
                (opt) => opt.value === formData[field.name]
              ) || null
            }
            onChange={(_, value) => handleAutocompleteChange(field.name, value)}
            renderInput={(params) => (
              <TextField
                {...params}
                label={field.label}
                variant="standard"
                fullWidth
                error={!!error}
                helperText={error}
                required={field?.required || false}
              />
            )}
          />
        );

      case "checkbox":
      case "switch":
        return (
          <FormControlLabel
            control={
              <Switch
                checked={Boolean(formData[field.name]) || false}
                onChange={handleSwitchChange(field.name)}
                color="primary"
              />
            }
            label={field.label}
            labelPlacement="start"
            sx={{
              justifyContent: "space-between",
              marginLeft: 0,
              marginRight: 0,
              width: "100%",
            }}
          />
        );

      default:
        return (
          <BTInput
            name={field.name}
            label={field.label}
            type={field.type || "text"}
            value={formData[field.name] || ""}
            onChange={handleChange}
            required={field?.required || false}
            variant="standard"
            fullWidth
            error={!!error}
            helperText={error}
            {...field.props}
          />
        );
    }
  };
  const renderCompanyField = (field, companyIndex) => {
    const error = errors[`companies[${companyIndex}].${field.name}`];
    return (
      <BTInput
        name={field.name}
        label={field.label}
        type={field.type || "text"}
        value={formData.p_allias[companyIndex][field.name] || ""}
        onChange={(e) => handleCompanyChange(companyIndex, e)}
        variant="standard"
        fullWidth
        required={field?.required || false}
        error={!!error}
        helperText={error}
        {...field.props}
      />
    );
  };
  const partyFields = [
    {
      name: "p_name",
      label: "Party Name",
      type: "text",
      gridSize: { xs: 12, md: 4 },
      required: true,
    },
    {
      name: "p_address",
      label: "Party Address",
      type: "text",
      gridSize: { xs: 12, md: 4 },
      required: true,
    },
    {
      name: "p_mo_no",
      label: "Party Mo.No",
      type: "text",
      gridSize: { xs: 12, md: 4 },
      required: true,
    },
    {
      name: "p_email_1",
      label: "Party Email 1",
      type: "email",
      gridSize: { xs: 12, md: 4 },
      required: true,
    },
    {
      name: "p_email_2",
      label: "Party Email 2",
      type: "email",
      gridSize: { xs: 12, md: 4 },
      required: false,
    },
    {
      name: "p_code",
      label: "Party code",
      type: "text",
      gridSize: { xs: 12, md: 4 },
      required: true,
    },
    {
      name: "p_contact_person_1",
      label: "Contact Person 1",
      type: "text",
      gridSize: { xs: 12, md: 3 },
      required: false,
    },
    {
      name: "p_contact_person_1_mo_no",
      label: "Contact Person 1 Mo.No",
      type: "text",
      gridSize: { xs: 12, md: 3 },
      required: false,
    },
    {
      name: "p_contact_person_2",
      label: "Contact Person 2",
      type: "text",
      gridSize: { xs: 12, md: 3 },
      required: false,
    },
    {
      name: "p_contact_person_2_mo_no",
      label: "Contact Person 2 Mo.No",
      type: "text",
      gridSize: { xs: 12, md: 3 },
      required: false,
    },
    {
      name: "p_description",
      label: "Description",
      type: "text",
      gridSize: { xs: 12, md: 12 },
    },
  ];
  const partyReferenceFields = [
    {
      name: "p_ref_name",
      label: "Party Reference Name",
      gridSize: { xs: 12, md: 3 },
      required: false,
    },
    {
      name: "p_ref_mo_no",
      label: "Reference Contact Number",
      gridSize: { xs: 12, md: 3 },
      required: false,
    },
  ];
  const companyFields = [
    {
      name: "p_org_name",
      label: "Company Name",
      type: "text",
      gridSize: { xs: 12, md: 2 },
      required: true,
    },
    {
      name: "p_org_address_line1",
      label: "Company Address 1",
      type: "text",
      gridSize: { xs: 12, md: 2 },
    },
    {
      name: "p_org_address_line2",
      label: "Company Address 2",
      type: "text",
      gridSize: { xs: 12, md: 2 },
    },
    {
      name: "p_org_state",
      label: "State",
      type: "text",
      gridSize: { xs: 12, md: 2 },
    },
    {
      name: "p_org_pincode",
      label: "Pincode",
      type: "number",
      gridSize: { xs: 12, md: 2 },
      required: false,
    },
    {
      name: "p_org_gst",
      label: "Company GST",
      type: "text",
      gridSize: { xs: 12, md: 2 },
      required: true,
    },
  ];
  const addCompany = () => {
    setFormData((prev) => ({
      ...prev,
      p_allias: [...prev.p_allias, { ...initialCompanyState }],
    }));
  };
  function removeCompany(index) {
    setFormData((prev) => ({
      ...prev,
      p_allias: prev.p_allias.filter((_, idx) => idx !== index),
    }));
  }
  useEffect(() => {
    if (scrollRef.current) {
      scrollRef.current.scrollTop = scrollRef.current.scrollHeight;
    }
  }, [formData?.p_allias]);
  return (
    <BTDialogBox
      open={Boolean(open)}
      fullWidth
      maxWidth="xl"
      maxHeight="550px"
      minHeight="550px"
      onSubmit={submitParty}
      close={handleClose}
      ref={scrollRef}
      title={actionType === 1 ? "Add party" : "Edit party"}
      buttons={[
        {
          name: "Cancel",
          color: "secondary",
          size: "small",
          onClick: handleClose,
        },
        {
          name: actionType === 1 ? "Submit" : "Edit",
          variant: "gradient",
          type: "submit",
          color: "dark",
          size: "small",
          loading: loading,
          loadingComponent: (
            <Fragment>
              <svg width={0} height={0}>
                <defs>
                  <linearGradient
                    id="my_gradient"
                    x1="0%"
                    y1="0%"
                    x2="0%"
                    y2="100%"
                  >
                    <stop offset="0%" stopColor="#e01cd5" />
                    <stop offset="100%" stopColor="#1CB5E0" />
                  </linearGradient>
                </defs>
              </svg>
              <CircularProgress
                size={22}
                sx={{
                  "svg circle": { stroke: "url(#my_gradient)" },
                }}
              />
            </Fragment>
          ),
          sx: { ml: 2, width: "80px" },
        },
      ]}
    >
      <Grid container spacing={1}>
        <Grid size={{ xs: 12, md: 12 }} p={0}>
          <BTTypography fontWeight={"bold"} variant="button">
            Party Details
          </BTTypography>
        </Grid>
        {partyFields.map((field) => (
          <Grid size={{ ...field.gridSize }} key={field.name}>
            {renderField(field)}
          </Grid>
        ))}
        <Grid size={{ xs: 12, md: 12 }} p={0}>
          <BTDivider sx={{ m: 1 }} />
          <BTTypography fontWeight={"bold"} variant="button">
            Party Reference
          </BTTypography>
        </Grid>
        {partyReferenceFields.map((field) => (
          <Grid size={{ ...field.gridSize }} key={field.name}>
            {renderField(field)}
          </Grid>
        ))}
        <Grid size={{ xs: 12, md: 12 }} p={0}>
          <BTDivider sx={{ m: 1 }} />
          <BTTypography fontWeight={"bold"} variant="button">
            Company Details
          </BTTypography>
        </Grid>
        {companyFields.map((field) => (
          <Grid size={{ ...field.gridSize }} key={field.name}>
            {renderField(field)}
          </Grid>
        ))}
        <Grid size={{ xs: 12, md: 12 }}>
          <BTButton
            variant="outlined"
            color="dark"
            size="small"
            onClick={addCompany}
          >
            Add Another Company
          </BTButton>
        </Grid>
        {formData.p_allias.map((company, index) => (
          <Grid
            container
            border={"1px solid #80808069"}
            p={1}
            gap={1}
            borderRadius={"10px"}
            position="relative"
            key={index}
            width={"100%"}
          >
            <Fragment>
              {companyFields.map((field) => (
                <Grid
                  size={{ ...field.gridSize }}
                  key={`${index}-${field.name}`}
                >
                  {renderCompanyField(field, index)}
                </Grid>
              ))}
              <Grid position={"absolute"} right={"-16px"} top={"-16px"}>
                <IconButton onClick={() => removeCompany(index)}>
                  <Cancel color="dark" />
                </IconButton>
              </Grid>
            </Fragment>
          </Grid>
        ))}
      </Grid>
    </BTDialogBox>
  );
};

export default Addparty;
